import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/sample-logo.png'


const _hoisted_1 = { class: "flex flex-col h-full" }
const _hoisted_2 = { class: "flex items-center justify-center h-16" }
const _hoisted_3 = { class: "flex items-center justify-center space-x-2 px-2 w-full" }
const _hoisted_4 = { class: "w-full flex items-center justify-center flex-shrink-0" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 1,
  src: _imports_0,
  alt: "Logo",
  class: "w-full p-2"
}
const _hoisted_7 = { class: "flex justify-center items-center space-x-3 relative z-10 text-center" }
const _hoisted_8 = { class: "text-md font-medium truncate" }
const _hoisted_9 = { class: "p-4 border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-black" }
const _hoisted_10 = { class: "flex items-center justify-center space-x-2 text-xs text-gray-600 dark:text-gray-400" }

import { computed, watch, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getNavigationItems } from '@/router'
import { useBrand } from '@/composables/brand/useBrand'
import { useAuthStore } from '@/stores/auth'

// Props & Emits

export default /*@__PURE__*/_defineComponent({
  __name: 'Sidebar',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["update:isOpen"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

// Composables
const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()
const { currentBrand, brandLogo, brandColors, applyBrandColors } = useBrand()

// Computed Properties
const appTitle = computed(() => process.env.VUE_APP_TITLE || 'SP Team Template')

// Role-based navigation
const navigation = computed(() => {
  const userRole = authStore.currentUser?.role
  const effectiveRole = (userRole === 'admin' && authStore.isAdminViewMode)
    ? 'customer'
    : userRole
  return getNavigationItems([...router.options.routes], effectiveRole, currentBrand.value?.slug)
})

// Dynamic Styles
const sidebarStyle = computed(() => ({
  backgroundColor: brandColors.value.sidebarBg,
}))

const logoSectionStyle = computed(() => ({
  backgroundColor: brandColors.value.sidebarBg,
  borderBottomColor: 'rgba(255, 255, 255, 0.2)',
}))

const navSectionStyle = computed(() => ({
  backgroundColor: brandColors.value.sidebarBg,
}))

const activeNavStyle = computed(() => ({
  backgroundColor: brandColors.value.sidebarActiveBg,
}))

const inActiveNavStyle = computed(() => ({
  backgroundColor: '#ffffff',
}))

const hoverStyle = computed(() => ({
  backgroundColor: `${brandColors.value.hover}20`,
}))

// Methods
const isActive = (path: string) => route.path === path
const toggleSidebar = () => emit('update:isOpen', !props.isOpen)

// Apply brand colors on mount and when brand changes
onMounted(() => {
  applyBrandColors()
})

watch(() => currentBrand.value, () => {
  applyBrandColors()
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("aside", {
      class: _normalizeClass(["fixed inset-y-0 left-0 z-50 w-[17rem] bg-white dark:bg-black shadow-xl transform transition-all duration-300 ease-in-out lg:translate-x-0", { '-translate-x-full': !_ctx.isOpen, 'translate-x-0': _ctx.isOpen }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_unref(brandLogo))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _unref(brandLogo),
                    alt: _unref(currentBrand)?.name || 'Logo',
                    class: "w-full mt-12 object-contain h-24"
                  }, null, 8, _hoisted_5))
                : (_openBlock(), _createElementBlock("img", _hoisted_6))
            ])
          ])
        ]),
        _createElementVNode("nav", {
          class: "flex-1 mx-4 my-12 px-6 py-4 space-y-5 rounded-xl overflow-y-auto",
          style: _normalizeStyle(navSectionStyle.value)
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.value, (item) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: item.to,
              to: item.to,
              class: _normalizeClass(["group flex justify-center items-center mt-3 px-3 py-3.5 text-gray-700 rounded-full transition-all duration-200 relative overflow-hidden", {
            'text-white': isActive(item.to)
          }]),
              style: _normalizeStyle(isActive(item.to) ? activeNavStyle.value : inActiveNavStyle.value)
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(item.name === 'What is TCP?' && _unref(currentBrand)?.name?.toLowerCase() === 'falken' ? 'What is RHR?' : item.name), 1)
                ]),
                (!isActive(item.to))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "absolute inset-0 opacity-0 group-hover:opacity-100 transition-all duration-300",
                      style: _normalizeStyle(hoverStyle.value)
                    }, null, 4))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["to", "class", "style"]))
          }), 128))
        ], 4),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", null, "© " + _toDisplayString(new Date().getFullYear()), 1),
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "w-1 h-1 rounded-full bg-gray-400" }, null, -1)),
            _cache[1] || (_cache[1] = _createElementVNode("span", null, "Developed by Proweaver", -1))
          ])
        ])
      ])
    ], 2),
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 z-40 bg-black/50 backdrop-blur-sm lg:hidden transition-opacity duration-300",
          onClick: toggleSidebar
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})